import { type IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { formatData } from '@alltrails/filters/utils/mapStats';
import { ActivityFaq } from '../../../types/locationDetailsPages/shared';
import { TrailFaqLink } from '../FaqLink';

export const getBikingQuestion = (intl, locationName: string) =>
  intl.formatMessage({ defaultMessage: 'Are there biking trails available in {locationName}?' }, { locationName });

type BikingAnswerProps = {
  locationName: string;
  bikingTrails: ActivityFaq;
  languageRegionCode: LanguageRegionCode;
  intl: IntlShape;
};

export const BikingAnswer = ({ locationName, bikingTrails, intl, languageRegionCode }: BikingAnswerProps) => {
  const { count, mostPopular: trail } = bikingTrails;
  const displayStarRating = formatData(trail.starRating, 1, null, languageRegionCode);
  const displayReviewCount = formatData(trail.reviewCount, 0, null, languageRegionCode);

  if (count === 1) {
    return intl.formatMessage(
      {
        defaultMessage:
          'According to AllTrails.com, there is 1 biking trail in {locationName} which is {trail} with an average {rating} star rating from {reviewCount} community reviews.'
      },
      {
        locationName,
        trail: <TrailFaqLink trail={trail} languageRegionCode={languageRegionCode} />,
        rating: displayStarRating,
        reviewCount: displayReviewCount
      }
    );
  }

  return intl.formatMessage(
    {
      defaultMessage:
        'According to AllTrails.com, there are {count} biking trails in {locationName} and the most popular is {trail} with an average {rating} star rating from {reviewCount} community reviews.'
    },
    {
      locationName,
      count,
      trail: <TrailFaqLink trail={trail} languageRegionCode={languageRegionCode} />,
      rating: displayStarRating,
      reviewCount: displayReviewCount
    }
  );
};
